<div class="container mx-auto p-6 bg-transparent h-screen overflow-y-auto">
    <h1 class="text-3xl font-bold mb-8 text-white border-b border-gray-700 pb-4">Studies</h1>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div *ngFor="let repo of repositoriesList"
            class="bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg p-6 transform transition-all duration-300 hover:scale-103 hover:shadow-xl border border-gray-700 cursor-pointer"
            (click)="onRepositoryClick(repo)">
            <div class="flex items-center mb-4">
                <div [class]="'w-12 h-12 bg-blue-900/50 rounded-lg flex items-center justify-center mr-4'">
                    <svg [class]="'w-6 h-6 text-blue-400'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4">
                        </path>
                    </svg>
                </div>
                <h2 class="text-xl font-bold text-white">{{ repo.name }}</h2>
            </div>
            <div class="flex justify-between items-center border-t border-gray-700 pt-3 mt-2">
                <p class="text-gray-300 font-medium">{{ user?.name }}</p>
                <p class="text-gray-400 text-sm italic">updated at {{ repo.created_at | date:'dd/MM/yyyy' }}</p>
            </div>
        </div>
    </div>
    <app-create-repo></app-create-repo>
</div>
